/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_COLLABORATES_WITH_OTHER_FACILITIES_ON_THE_DEVELOPMENT_',
              'FACILITY_PARTICIPATES_IN_MULTI_STAKEHOLDER_OR_INDUSTRY_FORUMS_T',
              'FACILITY_ENGAGES_WITH_KEY_LOCALLY_IMPACTED_STAKEHOLDERS_TO_IMPR',
              'FACILITY_ENGAGES_WITH_KEY_REGIONAL___INTERNATIONAL_STAKEHOLDERS',
              'FACILITY_ENGAGES__EITHER_DIRECTLY_OR_VIA_INDUSTRIAL_TRADE_ASSOC',
              'OTHER',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    did_the_fac_participate_in_any_of_the_following_activities_rela_3: valueSchema,
  },
}
